import EmbedBlockPreview from "./EmbedBlockPreview";

export default EmbedBlockPreview;